import React, { useState, useEffect } from "react";
import SimpleImageSlider from "react-simple-image-slider";
import '../ProductDetail.css';
import { images } from './axAdult';

export default function AdultSlider(props) {
  const [randomImages, setRandomImages] = useState([]);

  const shuffleArray = (array) => {
    const shuffled = [...array];
    for (let i = shuffled.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }
    return shuffled;
  };

  const getRandomImages = (array, num) => {
    const shuffledImages = shuffleArray(array);
    return shuffledImages.slice(0, num);
  };

  
  useEffect(() => {
    const images2 = getRandomImages(images, 20);
    setRandomImages(images2);
  }, []);

  if (randomImages.length === 0) return null;

  return (
    <SimpleImageSlider
      width={props.width || 250}
      height={props.height || 150}
      images={randomImages.map(item => ({
        url: item.src,
        alt: item.Alt,
        id: item.id
      }))}
      showBullets={false}
      showNavs={false}
      slideDuration={3}
      autoPlay={true}
      bgColor=""
      style={{ borderRadius: '8px', objectFit: "contain" ,padding:0.1}} // key change
    />
  );
}
